export const THEME_CHANGED = "progpath-theme-change";

export function getSavedTheme() {
  try {
    return localStorage.getItem("theme") === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function applyTheme(value) {
  const theme = value === "dark" ? "dark" : "light";
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = `only ${theme}`;
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", theme === "dark" ? "#0f1726" : "#f1f3fa");
  return theme;
}

export function saveTheme(value) {
  const theme = applyTheme(value);
  try {
    localStorage.setItem("theme", theme);
  } catch {
    // The chosen theme still applies when browser storage is unavailable.
  }
  window.dispatchEvent(new CustomEvent(THEME_CHANGED, { detail: theme }));
}
